import { createApi } from "./apiFactory";
import {
  Backend_PLPS_PROXY,
  plpsUtilsURL,
  plpsPlatformAgentsURL,
  plpsUtilsURLToken,
  plpsPlatformAgentsURLToken,
} from "../../constant";

export const api = createApi({
  baseURL: Backend_PLPS_PROXY,
  utilsURL: plpsUtilsURL,
  utilsToken: plpsUtilsURLToken,
  platformAgentsToken: plpsPlatformAgentsURLToken,
});
